import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty'
import { SUPPORT_EMAIL } from './support'

export function PlanOptionsUnavailable({
  variant,
  onRetry,
}: {
  variant: 'empty' | 'error'
  onRetry: () => void
}) {
  return (
    <Empty role="status" className="border border-dashed">
      <EmptyMedia variant="icon">
        <AlertTriangle className="h-5 w-5" />
      </EmptyMedia>
      <EmptyHeader>
        <EmptyTitle>{variant === 'error' ? "Couldn't load plans" : 'Plans aren’t available right now'}</EmptyTitle>
        <EmptyDescription>
          {variant === 'error'
            ? 'Something went wrong loading your billing plans.'
            : "We don't have any billing plans to show right now."}{' '}
          Try again, or contact support if this continues.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button variant="outline" onClick={onRetry}>
            Try again
          </Button>
          <Button variant="outline" asChild>
            <a href={`mailto:${SUPPORT_EMAIL}`}>Contact support</a>
          </Button>
        </div>
      </EmptyContent>
    </Empty>
  )
}
